import { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import PageHeader from "../../components/PageHeader/PageHeader";
import CommonTable from "../../components/CommonTable/CommonTable";
import { FaEye, FaTimes } from "react-icons/fa";
// import useTabStore from "../../localStore/useTabStore";
import { post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import moment from "moment";
import { toast } from "react-toastify";
import usePermission from "../../customHook/usePermission";

const BlockedSeller = () => {
  const blockTab = 1;
  const arr = [
    { id: 1, name: "Report List" },
    { id: 2, name: "Blocked Users" },
  ];

  const location = useLocation();

  const [tab, setTab] = useState(1);
  const tabRef = useRef(1);

  const [data, setData] = useState([]);
  const [page, setPage] = useState(location?.state?.page || 1);
  const [totalCount, setTotalCount] = useState();
  const [pagination, setPagination] = useState(null);
  const [searchText, setSearchText] = useState("");
  const pageRef = useRef(page);
  const preSearchPageRef = useRef(page);

  const permission = usePermission();

  const handleSelect = (i) => {
    setTab(i.id);
    tabRef.current = i?.id;
    // set("blockTab", i?.id);
  };

  const navigate = useNavigate();

  const handleView = (i) => {
    navigate("/blocked-view", {
      state: {
        item: i,
        id: i?.id,
        page: page,
      },
    });
  };

  console.log("tabRef", tabRef.current);

  const handleUnblock = async (id) => {
    let payload = {
      user_id: id,
    };

    let res = await post(URLS.UNBLOCK_USERS_ACTION, payload);
    if (res?.status == "success") {
      toast.success(res?.message);
      fetchData();
    }
  };

  const fetchData = async () => {
    let payload = {
      // page: page,
      search: searchText,
      type: tab == 1 ? "reports" : "blocked_users",
    };
    let url = `${URLS.BLOCKED_USERS_LIST}?page=${page}`;
    let res = await post(url, payload);
    if (res?.status == "success") {
      setData(res?.data);
      setTotalCount(res?.count || 0);
      setPagination({
        current_page: res?.current_page || 1,
        last_page: res?.total_pages || 1,
      });
    }
  };

  useEffect(() => {
    pageRef.current = page;
  }, [page]);

  useEffect(() => {
    if (location?.state?.page) {
      // clear state after using it
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [page, searchText, tab]);

  const columns = useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "",
        disableSortBy: true,
        width: "1%",
        Cell: ({ row }) => {
          return <span className="sno">{row.index + 1}</span>;
        },
      },
      {
        Header: "Report By",
        accessor: "report_by",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value || "N/A"}</p>;
        },
      },
      {
        Header: "Report to",
        accessor: "report_to",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value || "N/A"}</p>;
        },
      },
      {
        Header: "Order ID",
        accessor: "order_id",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value}</p>;
        },
      },
      {
        Header: "Date & Time",
        accessor: "date_time",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value}</p>;
        },
      },
    ];

    let action = {
      Header: "Action",
      accessor: "action",
      disableSortBy: true,
      width: "20%",
      Cell: ({ row }) => {
        return (
          <>
            {permission?.includes("CAN-VIEW-BLOCKED_SELLER") && (
              <button
                className="action-btn d-flex ac-jc"
                onClick={() => handleView(row?.original)}
              >
                <FaEye />
              </button>
            )}
          </>
        );
      },
    };

    return [...d, action];
  }, [page]);

  const columnsTwo = useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "",
        disableSortBy: true,
        width: "1%",
        Cell: ({ row }) => {
          return <span className="sno">{row.index + 1}</span>;
        },
      },
      {
        Header: "Blocked User",
        accessor: "name",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value || "N/A"}</p>;
        },
      },
      {
        Header: "Date & Time",
        accessor: "date_time",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value}</p>;
        },
      },
      {
        Header: "Remaining Days",
        accessor: "remaining_days",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value}</p>;
        },
      },
    ];

    let action = {
      Header: "Action",
      accessor: "action",
      disableSortBy: true,
      width: "20%",
      Cell: ({ row }) => {
        return (
          <>
            {permission?.includes("CAN-VIEW-BLOCKED_SELLER") && (
              <button
                className="action-btn-unblock d-flex ac-jc"
                onClick={() => handleUnblock(row?.original?.id)}
              >
                Unblock
              </button>
            )}
          </>
        );
      },
    };

    return [...d, action];
  }, [page]);

  const handleClearSearch = () => {
    setSearchText("");
    setPage(preSearchPageRef.current || 1);
  };

  return (
    <div>
      <PageHeader title="Blocked Seller" />
      <div className="d-flex gap-5 mb-5">
        {arr.map((i) => {
          return (
            <button
              onClick={() => handleSelect(i)}
              className={
                tab == i.id ? "header-action-btn" : "header-action-white-btn"
              }
              key={i.id}
            >
              {i.name}
            </button>
          );
        })}
      </div>

      <div className="header-row">
        <h2 className="total-count">Total: {totalCount || 0}</h2>

        <div className="search-wrapper">
          <input
            type="text"
            placeholder="Search"
            className="search-input"
            value={searchText || ""}
            onChange={(e) => {
              const val = e.target.value;

              if (!searchText && val) {
                preSearchPageRef.current = page || 1;
                setPage(1);
              } else if (searchText && !val) {
                setPage(preSearchPageRef.current || 1);
              }

              setSearchText(val);
            }}
          />
          {searchText && (
            <FaTimes
              className="search-clear-icon"
              onClick={handleClearSearch}
            />
          )}
        </div>
      </div>

      <CommonTable
        columns={tab == 1 ? columns : columnsTwo}
        data={data || []}
        pagecount={pagination}
        setPageno={setPage}
        pageno={page || 1}
      />
    </div>
  );
};

export default BlockedSeller;
